var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComponentsButtonIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74349 5.56062C6.47088 5.56062 6.22196 5.37816 6.14873 5.10247L5.40411 2.28676C5.31734 1.95814 5.51304 1.62122 5.84165 1.53445C6.17088 1.44706 6.50688 1.64337 6.59395 1.97199L7.33857 4.7877C7.42533 5.11631 7.22964 5.45324 6.90103 5.54001C6.84841 5.55385 6.79549 5.56062 6.74349 5.56062Z",
    fill: "#3030AD",
    stroke: "#3030AD",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94497 7.36015C4.89297 7.36015 4.84005 7.35369 4.78713 7.33953L1.97176 6.59461C1.64345 6.50753 1.44745 6.17091 1.53422 5.8423C1.62099 5.51399 1.95637 5.31676 2.28652 5.40476L5.1019 6.14968C5.4302 6.23676 5.6262 6.57338 5.53943 6.90199C5.46682 7.178 5.21759 7.36015 4.94497 7.36015Z",
    fill: "#3030AD",
    stroke: "#3030AD",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8708 12.616C15.8188 12.616 15.7658 12.6095 15.7129 12.5954L12.8975 11.8505C12.5692 11.7634 12.3732 11.4268 12.46 11.0982C12.5468 10.7698 12.8818 10.5726 13.2123 10.6606L16.0277 11.4055C16.356 11.4926 16.552 11.8292 16.4652 12.1579C16.3923 12.4339 16.1434 12.616 15.8708 12.616Z",
    fill: "#3030AD",
    stroke: "#3030AD",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 16.4862C11.727 16.4862 11.4781 16.3037 11.4048 16.028L10.6602 13.2126C10.5734 12.884 10.7691 12.5471 11.0978 12.4603C11.4273 12.3726 11.763 12.5693 11.8501 12.8979L12.5947 15.7133C12.6814 16.0419 12.4857 16.3788 12.1571 16.4656C12.1045 16.4794 12.0516 16.4862 11.9996 16.4862Z",
    fill: "#3030AD",
    stroke: "#3030AD",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.481 10.0503C12.3235 10.0503 12.1663 9.99031 12.046 9.87C11.8056 9.62969 11.8056 9.24015 12.046 8.99954L15.9499 5.09613C16.1902 4.85613 16.5798 4.85582 16.8201 5.09613C17.0604 5.33644 17.0604 5.72598 16.8201 5.9666L12.9161 9.87031C12.7958 9.99031 12.6383 10.0503 12.481 10.0503Z",
    fill: "#3030AD",
    stroke: "#3030AD",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3844 6.14733C16.2269 6.14733 16.0697 6.08733 15.9494 5.96702L12.0328 2.05039C11.7925 1.81008 11.7925 1.42054 12.0328 1.18023C12.2731 0.939923 12.6626 0.939923 12.9029 1.18023L16.8195 5.09687C17.0598 5.33717 17.0598 5.72672 16.8195 5.96702C16.6992 6.08702 16.542 6.14733 16.3844 6.14733Z",
    fill: "#3030AD",
    stroke: "#3030AD",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56477 6.13441C8.40723 6.13441 8.25 6.07441 8.12969 5.9541C7.88939 5.71379 7.88939 5.32425 8.12969 5.08394L12.0328 1.18023C12.2731 0.939923 12.6626 0.939923 12.9029 1.18023C13.1432 1.42054 13.1432 1.81008 12.9029 2.05039L8.99984 5.9541C8.87954 6.0741 8.72231 6.13441 8.56477 6.13441Z",
    fill: "#3030AD",
    stroke: "#3030AD",
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53132 16.9996C5.37378 16.9996 5.21655 16.9396 5.09625 16.8193C4.85594 16.579 4.85594 16.1895 5.09625 15.9492L8.99992 12.0455C9.24022 11.8052 9.62976 11.8052 9.87007 12.0455C10.1104 12.2858 10.1104 12.6753 9.87007 12.9156L5.9664 16.8193C5.84609 16.9396 5.68855 16.9996 5.53132 16.9996Z",
    fill: "#3030AD",
    stroke: "#3030AD",
    strokeWidth: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53129 17.0002C5.37375 17.0002 5.21652 16.9402 5.09621 16.8199L1.18023 12.9039C0.939923 12.6636 0.939923 12.2741 1.18023 12.0337C1.42054 11.7934 1.81007 11.7934 2.05038 12.0337L5.96636 15.9501C6.20667 16.1904 6.20667 16.5799 5.96636 16.8202C5.84605 16.9402 5.68852 17.0002 5.53129 17.0002Z",
    fill: "#3030AD",
    stroke: "#3030AD",
    strokeWidth: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6153 13.0836C1.45777 13.0836 1.30054 13.0236 1.18023 12.9033C0.939923 12.663 0.939923 12.2735 1.18023 12.0332L5.0836 8.12945C5.3239 7.88914 5.71344 7.88914 5.95375 8.12945C6.19405 8.36976 6.19405 8.7593 5.95375 8.99961L2.05038 12.9036C1.93007 13.0236 1.77284 13.0836 1.6153 13.0836Z",
    fill: "#3030AD",
    stroke: "#3030AD",
    strokeWidth: 0.3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponentsButtonIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/componentsButtonIcon.c3339378444b32a939401b701cb0bc25.svg";